import styles from './PlacingOrderPoint.module.scss';
import InfoIcon from '@assets/icons/info-grey-18.svg';
import PencilIcon from '@assets/icons/pencil-grey-18.svg';
import { IPlacingOrderPointProps, TPlacingOrderPointCol } from '../../types';
import { Text, TextColor, TextSize, TextWeight } from '@components/Text';
import { Tooltip } from '@components/new/Tooltip';

const PlacingOrderPoint: React.FC<IPlacingOrderPointProps> = (props: IPlacingOrderPointProps): React.ReactElement => {
  const { actionEdit, cols, rows, title } = props;

  return (
      <div className={styles.point}>
        {title && (
            <Text
                color={TextColor.PRIMARY}
                size={TextSize.L}
                weight={TextWeight.BOLD}
            >
              {title}
            </Text>
        )}
        {actionEdit && (
            <button
                className={styles.pointAction}
                onClick={actionEdit}
            >
              <img
                  src={PencilIcon}
                  alt="Pencil"
              />
            </button>
        )}
        {cols && (
            <div className={styles.pointList}>
              {cols.map((item: TPlacingOrderPointCol, index: number) => (
                  <div
                      className={styles.pointListItem}
                      key={index}
                  >
                    <Text
                        color={TextColor.PRIMARY}
                        size={TextSize.XS}
                        weight={TextWeight.MEDIUM}
                    >
                      {item.title}
                    </Text>
                    <div className={typeof item.value === 'string' ? styles.pointListItemValue : styles.pointListItemValueDouble}>
                      {item.icon && (
                          <img
                              className={styles.pointListItemValueIcon}
                              alt={item.icon}
                              src={item.icon}
                          />
                      )}
                      {(typeof item.value === 'string' || typeof item.value === 'number') && (
                          <Text
                              color={item.color ?? TextColor.PRIMARY}
                              size={TextSize.L}
                              weight={TextWeight.BOLD}
                          >
                            {item.value}
                          </Text>
                      )}
                      {Array.isArray(item.value) && (
                          item.value.map((value: string, index: number) => (
                              <>
                                <Text
                                    color={item.color ?? (index % 2 === 0 ? TextColor.PRIMARY : TextColor.DARK_MUTED)}
                                    key={index}
                                    size={index % 2 === 0 ? TextSize.L : TextSize.XS}
                                    weight={index % 2 === 0 ? TextWeight.BOLD : TextWeight.NORMAL}
                                >
                                  {value}
                                </Text>
                              </>
                          ))
                      )}
                      {item.tooltip && (
                          <Tooltip
                              action={
                                <img
                                    className={styles.pointListItemValueIcon}
                                    alt="Info"
                                    src={InfoIcon}
                                />
                              }
                              position="top"
                              text={item.tooltip}
                          />
                      )}
                    </div>
                  </div>
              ))}
            </div>
        )}
        {rows && (
            <div className={styles.pointDescription}>
              {rows.map((item: string | undefined, index: number) => (
                  <Text
                      color={index % 2 === 0 ? TextColor.PRIMARY : TextColor.DARK_MUTED}
                      key={index}
                      size={TextSize.S}
                  >
                    {item}
                  </Text>
              ))}
            </div>
        )}
      </div>
  );
};

export default PlacingOrderPoint;
